<template>
    <div class="section-scene son">
      <div class="son-enter son-enter-end">
        <img :src="static_img_url + 'pic/index/logo.png'" class="main-logo">
        <div class="content">
            <p><img :src="static_img_url + 'pic/index/logo1.png'" class="logo-vb100"></p>
            <p><img :src="static_img_url + 'pic/index/son_rank.png'" class="son_rank"></p>
            <p class="summary">
                新榜样崛起的脊背<br>
                指引着潮水涌动的方向
            </p>
            <a href="http://vcbeat-vb100.mikecrm.com/HA6tLZ4" target="_blank" class="son-href">报名参选</a>
        </div>
        <!-- 主图 -->
        <div class="pic-container pic-container-enter">
            <div class="swiper-container gallery-top" ref="slider">
                <div class="swiper-wrapper swiper-no-swiping">
                    <div class="swiper-slide" v-for=" (item,index) in imgs" :key="index">
                        <img :src="static_img_url + item.url">
                    </div>
                </div>
            </div>
        </div>
        <!-- 切换按钮 -->
        <div class="add-btns">
            <div class="btns swiper-button-prev btns-enter">
                <i class="iconfont">&#xe679;</i>
            </div>
            <div class="btns swiper-button-next btns-enter">
                <i class="iconfont">&#xe678;</i>
            </div>
        </div>
        <!-- 略缩图 -->
        <div class="gallery-thumbs-container gallery-thumbs-container-enter">
            <div class="gallery-thumbs">
                <div v-for=" (item,index) in imgs" 
                    :key="index" class="min-pic" 
                    :class=" index == activeIndex - 1? 'active-img' : ''"
                    @click="changeImg(index + 1)">
                    <img v-if="item.mini_url" :src="static_img_url + item.mini_url">
                </div>
            </div>
        </div>
      </div>
      <div class="son-leave translate-down"></div>
    </div>
</template>

<script>
import { timeoutSync } from 'js/common.js'
import { anima_mixins } from 'js/anima_mixins.js'
import Swiper from "swiper"

export default {
  mixins:[anima_mixins],
  data() {
    return {
        static_img_url: process.env.VUE_APP_CDN,
        defaultPage: 5,

        imgs:[
            { url: 'pic/son/son_bg.png', mini_url: '' },
            { url: 'pic/son/1.png', mini_url: 'pic/son/mini/1.png' },
            { url: 'pic/son/2.png', mini_url: 'pic/son/mini/2.png' },
            { url: 'pic/son/3.png', mini_url: 'pic/son/mini/3.png' },
            { url: 'pic/son/4.png', mini_url: 'pic/son/mini/4.png' },
            { url: 'pic/son/5.png', mini_url: 'pic/son/mini/5.png' },
            { url: 'pic/son/6.png', mini_url: 'pic/son/mini/6.png' },
            { url: 'pic/son/7.png', mini_url: 'pic/son/mini/7.png' },
            { url: 'pic/son/8.png', mini_url: 'pic/son/mini/8.png' },
            { url: 'pic/son/9.png', mini_url: 'pic/son/mini/9.png' },
            { url: 'pic/son/10.png', mini_url: 'pic/son/mini/10.png' },
            { url: 'pic/son/11.png', mini_url: 'pic/son/mini/11.png' },
            { url: 'pic/son/12.png', mini_url: 'pic/son/mini/12.png' },
            { url: 'pic/son/13.png', mini_url: 'pic/son/mini/13.png' },
            { url: 'pic/son/14.png', mini_url: 'pic/son/mini/14.png' },
            { url: 'pic/son/15.png', mini_url: 'pic/son/mini/15.png' },
            { url: 'pic/son/16.png', mini_url: 'pic/son/mini/16.png' },
            { url: 'pic/son/17.png', mini_url: 'pic/son/mini/17.png' },
            { url: 'pic/son/18.png', mini_url: 'pic/son/mini/18.png' },
            { url: 'pic/son/19.png', mini_url: 'pic/son/mini/19.png' },
            { url: 'pic/son/20.png', mini_url: 'pic/son/mini/20.png' },
            { url: 'pic/son/21.png', mini_url: 'pic/son/mini/21.png' },
            { url: 'pic/son/22.png', mini_url: 'pic/son/mini/22.png' }
        ],
        galleryTop: '',
        activeIndex: 1
    };
  },
  watch:{
    activePage(n,o){ // 监听进入
      if( this.activePage == this.defaultPage && !this.galleryTop ){
        this.initSwiper()
      }
    }
  },
  methods:{
      initSwiper(){
        let _that = this
        _that.galleryTop = new Swiper('.gallery-top', {
            spaceBetween: 0,
            speed: 500,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                slideChangeTransitionStart:function() {
                    if( this.activeIndex == _that.imgs.length + 1){
                        return _that.activeIndex = 1
                    }
                    if( this.activeIndex == 0){
                        return _that.activeIndex = _that.imgs.length 
                    }
                    _that.activeIndex = this.activeIndex
                }
            }
        });
      },
      changeImg(index){
          this.activeIndex = index
          this.galleryTop.slideTo(index, 1000, false);
      },

      async downEnter(){
        // console.log('son:下 进入')
        await timeoutSync(() => {
          $('.son-enter').removeClass('son-enter-end')
        },50)
        await timeoutSync(() => {
            $('.pic-container').removeClass('pic-container-enter')
            $('.btns').removeClass('btns-enter')
            $('.gallery-thumbs-container').removeClass('gallery-thumbs-container-enter')
        },200)
        await timeoutSync(() => {
          this.$emit('setLock',true)
        },600)
      },
      async upEnter(){
        // console.log('son:上 进入')
        await timeoutSync(() => {
          $('.son-leave').addClass('translate-down')
        },100)
        await timeoutSync(() => {
          this.$emit('setLock',true)
        },600)
      },

      async upLeave(){
        // console.log('son:上 退出')
        this.$emit('setLock',false)
        $('.pic-container').addClass('pic-container-enter')
        $('.gallery-thumbs-container').addClass('gallery-thumbs-container-enter')
        $('.btns').addClass('btns-enter')
        await timeoutSync(() => {
            $('.son-enter').addClass('son-enter-end')
        },200)
        await timeoutSync(() => {
          this.$emit('setActivePage',this.nextPage)
        },600)
      },
      async downLeave(){
        // console.log('son:下 退出')
        this.$emit('setLock',false)
        $('.son-leave').removeClass('translate-down')
        await timeoutSync( () => {
          this.$emit('setActivePage',this.nextPage)
        },600)
      }
  }
};
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus';
@import '~styles/animation.stylus';
@import "../../../node_modules/swiper/dist/css/swiper.css";
.son
    .son-enter
      position absolute
      background #000000
      height 100vh
      width 100vw
      overflow hidden
      transition all .6s
      right 0
      &.son-enter-end
        width: 0
    .content
        position absolute
        z-index 10
        top px2vh(300)
        left px2vw(240)
        .logo-vb100
            height px2vh(75)
        .son_rank
            margin-top 40px
            height px2vh(56)
        .summary
            margin-top 40px
            font-size:32px;
            color:#FFFFFF
            line-height:46px;
            @media screen and (max-width: 1366px)
                font-size:20px;
                line-height:30px;
    .pic-container
        position absolute
        right 0
        top 0
        width px2vw(1440)
        height px2vh(700)
        background #CFCFCF
        transition all .7s
        overflow hidden
        .gallery-top
            position absolute
            right 0
            width: 75vw;
            height 100%
            .swiper-wrapper,
            .swiper-wrapper .swiper-slide
                width: 100%
                height 100%
                img 
                    display block
                    width: 100%
                    height 100%
                    object-fit: cover
                    object-position: 50% 50%
        &.pic-container-enter
            width: 0
    .gallery-thumbs-container
        position absolute
        width px2vw(1700)
        bottom px2vh(120)
        right px2vw(80)
        transition all .7s
        overflow hidden
        &.gallery-thumbs-container-enter
            width 0
        .gallery-thumbs
            display flex
            flex-direction row
            flex-wrap wrap
            justify-content: flex-end;
            width px2vw(1700)
            .min-pic
                cursor pointer
                width px2vw(120)
                // height px2vh(60)
                margin-left 10px
                margin-bottom: 15px;
                opacity: .5;
                transition all .4s
                min-width 85px
                &:hover
                    opacity: 1
                img 
                    width: 100%
                    height 100%
                    object-fit: cover
                    object-position: 50% 50%
                &.active-img
                    opacity: 1
                    transform translateY(-10px)
    .add-btns
        position absolute
        right 0
        top 0
        width px2vw(1440)
        height px2vh(700)
        display inline-flex
        flex-direction row
        .btns
            position absolute
            cursor: pointer;
            width:60px;
            height:60px;
            background:rgba(255,255,255,1);
            border-radius:50%;
            display flex
            align-items center
            justify-content center
            outline: none
            top unset
            bottom -30px
            transition all .3s
            i::selection
                background rgba(255,255,255,0);
            &:hover
                transform scale(1.1)
            &.btns:nth-child(1)
                left 140px
                right unset 
            &.btns:nth-child(2)
                left 220px
                right unset 
            &.btns-enter
                transform scale(0)
            @media screen and (max-width: 1366px)
                width:40px;
                height:40px;
                &.btns:nth-child(2)
                    left 200px
    .son-href
        display inline-block
        width:160px;
        height:46px;
        background:linear-gradient(-45deg,rgba(214,162,77,1),rgba(255,215,149,1));
        border-radius:23px;
        text-align center
        color #000000
        line-height 46px;
        margin-top 30px
        &:hover
            color #ffffff
    .son-leave
      position absolute
      width 100vw
      height 100vh
      z-index 20
      background #232323
      transition all .6s
      transform: translateY(0)
</style>